import { useState } from 'react';
import type { DataKYCFileTctWithFile } from '@dealstack/shared/lib/generated';
import { originalUploadFileId } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/component/Review/utils/certificationReview.utils';

/**
 * DC-825: lets the reviewer compare a certified copy with the investor's original upload. The
 * choice belongs to one file, so selecting another file shows its certified copy again.
 */
export const useOriginalUploadToggle = (selectedKycFile: DataKYCFileTctWithFile | undefined) => {
	const [originalShownFor, setOriginalShownFor] = useState<string | null>(null);
	const originalFileId = originalUploadFileId(selectedKycFile);
	const isViewingOriginal =
		!!originalFileId && !!selectedKycFile && originalShownFor === selectedKycFile.id;

	return {
		canViewOriginal: !!originalFileId,
		isViewingOriginal,
		originalFileId: isViewingOriginal ? originalFileId : undefined,
		setIsViewingOriginal: (value: boolean) =>
			setOriginalShownFor(value && selectedKycFile ? selectedKycFile.id : null),
	};
};
